const ReachOut = () => {
  //Check if the reachout ping exist return false if does not exist
  if (! document.querySelector('.reachout-toggle')) {
    return false;
  }
  const body = document.querySelector('body');
  const reach = document.querySelector('.reachout');
  const toggle = reach.querySelector('.reachout-toggle');
  const cta = reach.querySelector('.reachout-cta');
  const close = reach.querySelector('.reachout-close');
  const description = reach.querySelector('.description');
  const thanks = reach.querySelector('.thanks');
  const breakpoint = body.getAttribute('data-breakpoint');

  let isOpen;
  let isConfirmed;
  let isClosed;
  let timeout;

  showPing();

  // On Toggle Click
  toggle.addEventListener('click', function() {
    showForm();

    if (breakpoint === 'desktop') {
      window.addEventListener('scroll', onScroll);

      window.addEventListener('click', e => {
        showToggle(e.target);
      });
    }
  });

  // onClick Close button
  if (breakpoint !== 'desktop') {
    close.addEventListener('click', function() {
      showToggle();
    });
  }

  // onClick Send button
  cta.addEventListener('click', function() {
    // const formData = {
    //   name: '',
    //   email: '',
    //   page: '',
    //   date: Date(),
    // };

    // fetch(url, {
    //   method: 'POST',
    //   body: formData,
    // })
    //   .then(response => {})
    //   .catch(error => {});

    showConfirmed();
  });

  function showForm() {
    isClosed = reach.classList.contains('reachout--is-closed');

    if (isClosed) {
      reach.classList.remove('reachout--is-closed');
      reach.classList.add('reachout--is-open');

      setTimeout(() => {
        description.querySelector('.description-text').focus();
      }, 260);
    }
  }

  function showConfirmed() {
    reach.classList.remove('reachout--is-open');
    reach.classList.add('reachout--is-confirmed');

    timeout = setTimeout(() => showSuccess(), 5000);

    setAriaHidden(description);
    setAriaVisible(thanks);
    reach.querySelector('.thanks').focus();
    removeEL();
  }

  function showSuccess() {
    clearTimeout(timeout);

    reach.classList.remove('reachout--is-confirmed');
    reach.classList.add('reachout--is-success');

    sessionStorage.setItem('reachout_ping', true);

    hidePing();
  }

  function showToggle(e) {
    isOpen = reach.classList.contains('reachout--is-open');

    if (isOpen && (! reach.contains(e) || e === close)) {
      reach.classList.remove('reachout--is-open');
      reach.classList.add('reachout--is-closed');

      toggle.setAttribute('aria-expanded', 'false');

      removeEL();
    }
  }

  function onScroll() {
    isOpen = reach.classList.contains('reachout--is-open');
    isConfirmed = reach.classList.contains('reachout--is-confirmed');

    isOpen && showToggle();
    isConfirmed && showSuccess();
  }

  function hidePing() {
    timeout = setTimeout(() => {
      reach.classList.remove('reachout--is-shown');
      reach.classList.remove('reachout--is-success');
      reach.classList.add('reachout--is-hidden');
    }, 5000);

    clearTimeout();
  }

  function showPing() {
    if (! sessionStorage.getItem('reachout_ping')) {
      reach.classList.remove('reachout--is-hidden');
      reach.classList.add('reachout--is-shown');
      reach.classList.add('reachout--is-closed');
    }
  }

  function removeEL() {
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('click', showToggle);
  }

  function setAriaHidden(target) {
    target.setAttribute('aria-hidden', true);
  }

  function setAriaVisible(target) {
    target.setAttribute('aria-hidden', false);
  }
};

export default ReachOut;
